import React, { LegacyRef } from 'react';
import { TotalsProgressBar } from '../ActivityTotals/TotalsProgressBar/TotalsProgressBar';
import CompactPageOwnerAvatarStory from '../CompactPageOwnerStory/CompactPageOwnerAvatarStory';
import TruncatedPageOwnerTitle from '../PageOwnerTitle/PageTitle';
import styles from './InstagramShare.scss';
import { PAGES_UI_FEATURE_IMAGE } from '../../constants/imageTemplateStrings';
import { JustGivingLogo } from '../JustGivingLogo/JustGivingLogo';
import classNames from 'classnames';

export enum IG_SHARE_TYPE {
  POST,
  STORY,
}

interface InstagramShareScreenshotProps {
  heroImageUrl: string;
  altText: string;
  screenshotRef: LegacyRef<HTMLDivElement>;
  className?: string;
  type: IG_SHARE_TYPE;
}

export const InstagramShareScreenshot: React.FunctionComponent<InstagramShareScreenshotProps> = ({
  heroImageUrl,
  altText,
  screenshotRef,
  className,
  type,
}) => {
  const isStory = type === IG_SHARE_TYPE.STORY;

  return (
    <div style={{ height: '0', overflow: 'hidden' }} id="container">
      <div
        className={
          isStory
            ? styles.storyContainer__screenshot__story
            : styles.container__screenshot
        }
        ref={screenshotRef}
      >
        <div
          className={classNames(
            styles.shareContainer,
            isStory
              ? styles.shareContainer__story__screenshot
              : styles.shareContainer__post__screenshot,
          )}
          ref={screenshotRef}
        >
          {isStory && (
            <div
              className={styles.logo__story__screenshot}
              id="logo"
              style={{ height: '0', overflow: 'hidden' }}
            >
              <JustGivingLogo />
            </div>
          )}
          <img
            src={`${heroImageUrl}?template=${PAGES_UI_FEATURE_IMAGE}`}
            alt={altText}
            className={
              isStory
                ? styles.shareModalImage__story__screenshot
                : styles.shareModalImage__post
            }
          />
          <div
            className={
              isStory
                ? styles.shareTextAndTotals__story__screenshot
                : styles.shareTextAndTotals__post__screenshot
            }
          >
            <TruncatedPageOwnerTitle
              truncateAt={isStory ? 75 : 60}
              className={styles.pageTitle}
            />
            <CompactPageOwnerAvatarStory linkToFrp={false} />
            <TotalsProgressBar isInstagramShare={true} />
          </div>
        </div>
      </div>
    </div>
  );
};
